/* omg: judge.me koristi hrvatski prijevod ("na temelju", "zvjezdica") - prepravi tekst u bosanski.
   judge.me widget se iscrtava asinhrono, pa pratimo promjene u njegovim elementima. */
(function () {
  var RULES = [
    [/\s*zvjezdica na temelju\s*/g, ' na osnovu '],
    [/na temelju/g, 'na osnovu']
  ];
  function fix(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue, o = t;
      for (var i = 0; i < RULES.length; i++) t = t.replace(RULES[i][0], RULES[i][1]);
      /* ispravna mnozina: 1 recenzija, 2-4 recenzije, 5+ (i 11-14) recenzija */
      t = t.replace(/(\d+)(\s+)recenzij[ae]\b/g, function (m, num, sp) {
        var n = parseInt(num, 10), l = n % 10, l2 = n % 100;
        var w = (l2 >= 11 && l2 <= 14) ? 'recenzija' : (l >= 2 && l <= 4) ? 'recenzije' : 'recenzija';
        return num + sp + w;
      });
      if (t !== o) n.nodeValue = t;
    }
  }
  function run() {
    document.querySelectorAll('.jdgm-widget, .jdgm-all-reviews-text, .jdgm-prev-badge, .jm-text, [class*="jdgm"]').forEach(fix);
  }
  var mo = new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var el = list[i].target.nodeType === 1 ? list[i].target : list[i].target.parentElement;
      if (el && el.closest && el.closest('.jdgm-widget, .jdgm-all-reviews-text, .jdgm-prev-badge, .jm-text, [class*="jdgm"]')) { run(); return; }
    }
  });
  function start() { run(); mo.observe(document.body, { childList: true, subtree: true, characterData: true }); setTimeout(function () { mo.disconnect(); }, 15000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
